
import { mapState } from 'vuex'
import { bus } from '~/assets/js/eventBus'
export default {
  props: {
    successDialog: {
      type: Boolean,
      default: false
    },
    // 是否展示关闭按钮
    isShowClose: {
      type: Boolean,
      default: false
    },
    isMediate: {
      type: String,
      default: '1' // 1 是评价
    },
    isEnterMediate: {
      type: Boolean,
      default: false
    },
    isQueue: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      isMobile: 'mobile'
    })
  },
  mouted() {
    // console.log('评价发布成功')
  },
  methods: {
    colseSuccessDialog() {
      this.$emit('colseSuccessDialog')
      bus.$emit('colseSuccessReload')
    },
    enterMediatePage() {
      this.$emit('enterMediatePage')
    }
  }
}
